<div *ngIf="showBackButton" class="back-button-wrapper">
  <button class="btn btn-link ml-5" (click)="onClick()"><i class="fas fa-chevron-left mr-5"></i>
    <ng-container i18n>Back</ng-container> </button>
</div>